/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLine: {
  name: 'line';
  data: string;
} = {
  name: 'line',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 4a1 1 0 0 0 1 1h2.586L4.293 17.293a1 1 0 1 0 1.414 1.414L18 6.414V9a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1Zm7 9a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0v-7Zm-4 2a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0v-5Zm-5 1a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
